"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const Animation_1 = require("../Animation");
const OverflowHidden = app_1.styled.div `
  overflow: hidden;
  ${(_, { $open }) => !$open && 'padding: 0 !important'}
`;
function Collapse({ open, keepInactive, children, }) {
    if (keepInactive) {
        return ((0, jsx_runtime_1.jsx)(Animation_1.Animation, Object.assign({ in: open, auto: "height" }, { children: (0, jsx_runtime_1.jsx)(OverflowHidden, { children: children }) })));
    }
    return (0, jsx_runtime_1.jsx)(Animation_1.Animation, Object.assign({ auto: "height" }, { children: open && children }));
}
exports.Collapse = Collapse;
